module.exports = __webpack_public_path__ + "img/test_k.08372dfa.png";